import { useEffect, useState } from "react";
import ClaimSidebar from "./ClaimSidebar";
import ClaimInsightsScreen from "./ClaimInsightsScreen";
import { useLocation } from "react-router-dom";
import { RpaServices } from "../services/RpaServices";
import { PatientServices } from "../services/PatientServices";
import { CaseStageContext } from "../dashboard/cases/contexts/CaseContexts";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CaseServices } from "../services/CaseServices";

const getCaseStage = (stage) => {
  return stage?.includes("admission")
    ? "admission"
    : stage?.includes("enhancement")
      ? "enhancement"
      : "discharge";
};

const DutWorkspace = () => {
  const location = useLocation();

  const selectedCase = location.state?.selectedCase;
  const [dutData, setDutData] = useState(null);
  const [latestStageData, setLatestStageData] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedImg, setSelectedImg] = useState(null);
  const [patientDetails, setPatientDetails] = useState(null);
  const [caseDetails, setCaseDetails] = useState(null);
  const [enhancementList, setEnhancementList] = useState([]);
  const [caseStage, setCaseStage] = useState(
    getCaseStage(
      selectedCase?.submasterstagestatuses?.[0]?.commandCenterStage?.toLowerCase(),
    ),
  );

  const fetchDutDetails = async () => {
    try {
      const response = await RpaServices.getDutCaseDetails(
        selectedCase?.pmjayRegistrationId,
      );

      setDutData(response.data.caseDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const fetchPatientDetails = async () => {
    try {
      const res = await PatientServices?.getPatientDetails(
        selectedCase?.patient?.id,
      );

      setPatientDetails(res?.data?.patient);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const fetchCaseDetails = async () => {
    try {
      const res = await CaseServices.getCaseDetails(selectedCase?.id);
      setCaseDetails(res?.data?.caseDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const fetchLatestCaseStage = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(
        selectedCase?.caseId || selectedCase?.id,
      );

      console.log("LATEST CASE STAGE RESPONSE", response?.data);

      setLatestStageData(response?.data);
    } catch (error) {
      console.error("LATEST CASE STAGE ERROR", error);
    }
  };
  useEffect(() => {
    if (!selectedCase?.pmjayRegistrationId) return;

    fetchDutDetails();
    fetchPatientDetails();
    fetchCaseDetails();
  }, [selectedCase]);
  useEffect(() => {
    if (!selectedCase?.id) return;

    fetchLatestCaseStage();
  }, [selectedCase]);
  useEffect(() => {
    if (!latestStageData?.documents?.length) return;

    let firstDoc = latestStageData.documents[0];

    // !selectedDocument && setSelectedDocument(firstDoc);

    if (selectedDocument) {
      const doc = latestStageData?.documents?.find(
        (document) => document?.id === selectedDocument?.id,
      );
      if (doc !== -1) {
        firstDoc = doc;
      }
    }
    setSelectedDocument(firstDoc);
    if (firstDoc?.documenturlmasters?.length) {
      setSelectedImg({
        idx: 0,
        ...firstDoc.documenturlmasters[0],
      });
    }
  }, [latestStageData]);

  return (
    <CaseStageContext.Provider
      value={{
        caseStage,
        setCaseStage,
        patientDetails,
        fetchPatientDetails,
        caseDetails,
        fetchCaseDetails,
        setSelectedDocument,
        setSelectedImg,
        fetchLatestCaseStage,
        latestStageData,
      }}
    >
      <div
        className="
        w-full
        min-h-screen
        flex
        gap-[12px]
        pt-[10px]
      "
      >
        {/* Sidebar */}
        <div className="shrink-0">
          <ClaimSidebar
            latestStageData={latestStageData}
            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}
            setSelectedImg={setSelectedImg}
          />
        </div>

        {/* Main Content */}
        <div className="flex-1 min-w-0">
          <ClaimInsightsScreen
            selectedCase={selectedCase}
            dutData={dutData}
            latestStageData={latestStageData}
            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}
            selectedImg={selectedImg}
            setSelectedImg={setSelectedImg}
            fetchLatestCaseStage={fetchLatestCaseStage}
          />
        </div>
      </div>
    </CaseStageContext.Provider>
  );
};

export default DutWorkspace;
